// Bilingual content dictionary for Batys Finance.
// Access via content[lang] where lang is "ru" | "kz".

export const content = {
  ru: {
    langLabel: "RU",
    brand: { line1: "BATYS", line2: "FINANCE", sub: "Микрофинансовая организация" },
    nav: [
      { id: "home", label: "Главная" },
      { id: "products", label: "Кредитование" },
      { id: "news", label: "Новости" },
      { id: "about", label: "О компании" },
      { id: "reporting", label: "Отчётность" },
    ],
    cta: { apply: "Подать заявку", products: "Наши продукты", calculator: "Рассчитать платёж", more: "Подробнее", all: "Все продукты", download: "Скачать", source: "Источник" },
    hero: {
      badge: "Финансирование бизнеса и физических лиц",
      titleLines: ["Быстрое", "финансирование", "для вашего дела"],
      subtitle:
        "Микрокредиты для физических лиц, индивидуальных предпринимателей (ИП), крестьянских хозяйств (КХ) и компаний (ТОО) по всей Западно-Казахстанской области. Решение — от 2 рабочих дней, без лишней бюрократии.",
      chips: ["до 20 млн ₸", "решение от 2 дней", "по всей ЗКО"],
      scroll: "Листайте вниз",
    },
    who: {
      kicker: "Кому подходит",
      title: "Финансирование под ваши цели",
      subtitle: "Для ИП, крестьянских хозяйств (КХ) и ТОО — гибко и по делу.",
      cards: [
        { icon: "recycle", title: "Пополнение оборотных средств", desc: "Закрывайте кассовые разрывы и держите бизнес в движении круглый год." },
        { icon: "tractor", title: "Покупка техники и оборудования", desc: "Обновляйте парк и производственные мощности без паузы в работе." },
        { icon: "sprout", title: "Семена, ГСМ и удобрения", desc: "Финансируйте посевную и подготовку к сезону вовремя." },
        { icon: "beef", title: "Приобретение скота", desc: "Расширяйте поголовье и наращивайте продуктивность хозяйства." },
        { icon: "briefcase", title: "Другие бизнес-цели", desc: "Индивидуальные решения под задачи вашего предприятия." },
      ],
    },
    advantages: {
      kicker: "Наши преимущества",
      title: "Почему выбирают Батыс Финанс",
      items: [
        { n: "01", title: "Быстрое одобрение", desc: "Решение по заявке — от 2 рабочих дней." },
        { n: "02", title: "Минимум документов", desc: "Компактный пакет без лишней бюрократии." },
        { n: "03", title: "Гибкий график погашения", desc: "Учитываем сезонность вашего бизнеса и денежные потоки." },
        { n: "04", title: "Прозрачные условия", desc: "Никаких скрытых комиссий — только понятные ставки." },
        { n: "05", title: "До 20 млн тенге", desc: "Финансирование, соразмерное задачам предприятия." },
      ],
    },
    figures: {
      kicker: "Батыс Финанс в цифрах",
      title: "Надёжный партнёр региона",
      stats: [
        { num: 2, prefix: "", suffix: "+ млрд ₸", label: "Портфель финансирования" },
        { num: 500, prefix: "", suffix: "+", label: "Клиентов по региону" },
        { num: 19, prefix: "", suffix: " лет", label: "На рынке ЗКО" },
        { num: 2, prefix: "от ", suffix: " дн.", label: "Средний срок решения" },
      ],
    },
    marquee: ["Быстро", "Надёжно", "Прозрачно", "Для бизнеса", "Западный Казахстан"],
    products: {
      kicker: "Кредитование",
      title: "Финансирование для бизнеса и физических лиц",
      subtitle: "Подберём подходящее решение для предпринимателей, компаний и частных клиентов.",
      businessTitle: "Для бизнеса",
      individuals: {
        title: "Кредитование физических лиц",
        desc: "Рассматриваем обращения частных клиентов и помогаем подобрать подходящее решение.",
        note: "Условия и доступные программы уточняются у специалиста.",
        rows: [
          ["Возраст", "от 21 до 75 лет"],
          ["Сумма", "от 500 тыс. до 20 млн ₸"],
          ["Срок", "от 12 до 36 месяцев"],
        ],
      },
      calculator: {
        kicker: "Калькулятор",
        title: "Рассчитайте ориентировочный платёж",
        amount: "Сумма финансирования",
        term: "Срок",
        termUnit: "месяцев",
        result: "Предварительный расчёт",
        monthly: "Ежемесячный платёж",
        total: "Общая сумма возврата",
        overpayment: "Переплата",
        note: "Расчёт является предварительным. Точные условия определяются после рассмотрения заявки.",
      },
      goals: [
        { name: "Пополнение оборотных средств", desc: "Закрывайте кассовые разрывы и держите бизнес в движении круглый год." },
        { name: "Покупка техники и оборудования", desc: "Обновляйте парк и производственные мощности без паузы в работе." },
        { name: "Посевная и уборочная кампания", desc: "Семена, ГСМ и удобрения — финансирование сезонных работ вовремя." },
        { name: "Приобретение и содержание скота", desc: "Расширяйте поголовье и обеспечивайте устойчивую работу хозяйства." },
        { name: "Развитие производства", desc: "Увеличивайте объёмы, запускайте новые направления и укрепляйте бизнес." },
        { name: "Ремонт и модернизация помещений", desc: "Обновляйте производственные и рабочие помещения под задачи компании." },
        { name: "Прочие бизнес-цели", desc: "Индивидуальные решения под конкретные задачи вашего предприятия." },
      ],
      items: [
        {
          tag: "Сезонный",
          name: "Агро-Сезон",
          desc: "Финансирование посевной и уборочной кампании с погашением после реализации урожая.",
          rows: [
            ["Сумма", "до 20 млн ₸"],
            ["Срок", "до 12 месяцев"],
            ["График", "сезонный, гибкий"],
          ],
        },
        {
          tag: "Оборот",
          name: "Оборотный",
          desc: "Пополнение оборотных средств для стабильной работы бизнеса в течение года.",
          rows: [
            ["Сумма", "до 15 млн ₸"],
            ["Срок", "до 24 месяцев"],
            ["График", "ежемесячный / гибкий"],
          ],
        },
        {
          tag: "Инвестиции",
          name: "Техника",
          desc: "Покупка сельхозтехники, оборудования и модернизация производства.",
          rows: [
            ["Сумма", "до 20 млн ₸"],
            ["Срок", "до 36 месяцев"],
            ["График", "аннуитет / индивидуально"],
          ],
        },
      ],
    },
    how: {
      kicker: "Как это работает",
      title: "Четыре шага до финансирования",
      steps: [
        { n: "01", title: "Заявка", desc: "Оставьте заявку онлайн или позвоните нам." },
        { n: "02", title: "Консультация", desc: "Менеджер уточнит цели и подберёт условия." },
        { n: "03", title: "Решение", desc: "Одобрение по заявке — от 2 рабочих дней." },
        { n: "04", title: "Финансирование", desc: "Получите средства и развивайте дело." },
      ],
    },
    geo: {
      kicker: "География",
      title: "Работаем по всей Западно-Казахстанской области",
      subtitle:
        "Головной офис — в Уральске. Финансируем предприятия и хозяйства во всех районах региона.",
      badge: "Уральск — головной офис",
      districts: [
        "Акжаикский район", "Байтерекский район", "Бокейординский район", "Бурлинский район",
        "Жангалинский район", "Жанибекский район", "Казталовский район", "Каратобинский район",
        "Сырымский район", "Таскалинский район", "Теректинский район", "Чингирлауский район",
      ],
    },
    about: {
      kicker: "О компании",
      title: "ТОО «МФО «Батыс Финанс»",
      lead:
        "Микрофинансовая организация, ориентированная на агробизнес и малый и средний бизнес Западного Казахстана.",
      paragraphs: [
        "Мы помогаем предпринимателям, крестьянским хозяйствам и компаниям получать финансирование тогда, когда это действительно нужно — к посевной, к покупке техники, к расширению дела.",
        "Наш подход — прозрачные условия, разумные сроки и индивидуальное внимание к каждому клиенту. Мы понимаем сезонность агробизнеса и выстраиваем график под реальные денежные потоки.",
        "Компания начала работу под названием «Теректа Финанс» («Теректі-Финанс» ШНҰ) и позже прошла ребрендинг в «Батыс Финанс» — с сохранением команды и подхода к работе с агробизнесом региона.",
      ],
      values: [
        { title: "Прозрачность", desc: "Понятные условия без скрытых комиссий." },
        { title: "Скорость", desc: "Быстрые решения без лишней бюрократии." },
        { title: "Партнёрство", desc: "Индивидуальный подход к каждому делу." },
      ],
      historyKicker: "История компании",
      historyTitle: "19 лет рядом с предпринимателями региона",
      historyNote: "От первого микрокредита — к системной поддержке бизнеса",
      history: [
        { year: "2007", title: "Основание компании", desc: "Компания начинает работу в Западном Казахстане." },
        { year: "2007–2008", title: "Запуск микрокредитования", desc: "Первые программы финансирования и развитие сети." },
        { year: "2013–2015", title: "Социальные программы", desc: "Поддержка региональных инициатив и внешнее финансирование." },
        { year: "2015–2017", title: "Расширение присутствия", desc: "Развитие офисов и работа с предпринимателями региона." },
        { year: "2016", title: "Ребрендинг", desc: "Компания продолжает работу под брендом «Батыс Финанс»." },
        { year: "Сегодня", title: "Поддержка бизнеса", desc: "Финансирование малого, среднего и агробизнеса." },
      ],
      awardsTitle: "Награды и признание",
      awardsHint: "Нажмите, чтобы увидеть документ",
      awards: [
        { title: "Диплом КазАгро «Үздік және сапалы есептер»", year: "2011" },
        { title: "Почётная грамота Министерства сельского хозяйства РК", year: "2013" },
        { title: "Грамота АО «Фонд финансовой поддержки сельского хозяйства»", year: "" },
        { title: "Сертификат EBRD/CAMCO «Лучшая МКО Западно-Казахстанской области»", year: "2013" },
        { title: "Сертификат EBRD/CAMCO «Лучшая МКО Западно-Казахстанской области»", year: "2015" },
        { title: "Сертификат стажировки в финансово-кредитных учреждениях Кыргызстана", year: "2016" },
      ],
      license: {
        title: "Лицензия на микрофинансовую деятельность",
        number: "№ 07.21.0001.М",
        date: "от 18.02.2021",
        issuer:
          "Выдана Управлением региональных представителей в г. Уральск Агентства РК по регулированию и развитию финансовых рынков.",
        note: "Полный текст документа — в разделе «Отчётность»",
      },
    },
    reporting: {
      kicker: "Отчётность",
      title: "Финансовая отчётность и раскрытие информации",
      subtitle:
        "Мы придерживаемся принципов открытости. Документы и отчётность доступны для ознакомления.",
      docs: [
        {
          name: "Лицензия на микрофинансовую деятельность № 07.21.0001.М",
          meta: "JPG · от 18.02.2021",
          href: "/documents/license-07-21-0001-m-ru.jpg",
        },
        {
          name: "Инструкция по урегулированию задолженности по микрокредитам",
          meta: "PDF · утв. 27.05.2022",
          href: "/documents/debt-settlement-instruction-2022.pdf",
        },
        { name: "Финансовая отчётность за 2025 год", meta: "PDF · 2025", href: "/documents/balance-2025.pdf" },
        { name: "Финансовая отчётность за 2024 год", meta: "PDF · 2024", href: "/documents/balance-2024.pdf" },
        { name: "Финансовая отчётность за 2023 год", meta: "PDF · 2023", href: "/documents/balance-2023.pdf" },
        { name: "Финансовая отчётность за 2022 год", meta: "PDF · 2022", href: "/documents/balance-2022.pdf" },
        { name: "Финансовая отчётность за 2021 год", meta: "PDF · 2021", href: "/documents/balance-2021.pdf" },
        { name: "Финансовая отчётность за 2020 год", meta: "PDF · 2020", href: "/documents/balance-2020.pdf" },
      ],
    },
    news: {
      kicker: "Новости",
      title: "Новости и события",
      subtitle: "Что происходит в Батыс Финанс и в регионе.",
      items: [
        {
          date: "01.08.2026",
          cat: "Рынок",
          title: "Урожай зерна в Казахстане — прогноз около 24 млн тонн",
          excerpt: "Минсельхоз РК: уборочная идёт быстрее прошлогодней, ожидается рекордный урожай масличных. Ниже кредитные риски в АПК — выше спрос на финансирование техники и оборотного капитала.",
          href: "https://primeminister.kz/ru/news/prognoz-po-sboru-zerna-v-kazaxstane-sostavliaet-24-mln-tonn-minselxoz-30540",
          external: true,
        },
        {
          date: "20.07.2026",
          cat: "Рынок",
          title: "Рост сельского хозяйства ускорился до 4,4%",
          excerpt: "По итогам первого полугодия 2026 года объём валовой продукции сельского хозяйства вырос на 4,4%, растениеводство — на 7,7%. Инвестиции в отрасль выросли на 36,4% за пять месяцев.",
          href: "https://inbusiness.kz/ru/last/selskoe-hozyajstvo-kazahstana-vyroslo-na-4-4",
          external: true,
        },
        {
          date: "15.05.2026",
          cat: "Рынок",
          title: "Экспорт продукции АПК вырос на 36%",
          excerpt: "За январь–апрель 2026 года экспорт продукции АПК достиг $3 млрд, план на год — $7,2 млрд. Больше валютной выручки у хозяйств — выше спрос на оборотное финансирование.",
          href: "https://www.kt.kz/rus/ekonomika/tokaev_prinyal_ministra_selskogo_hozyaystva_1377994694.html",
          external: true,
        },
        {
          date: "30.04.2025",
          cat: "Компания",
          title: "Опубликована финансовая отчётность за 2024 год",
          excerpt: "В разделе «Отчётность» доступны актуальные финансовые документы компании — в соответствии с требованиями раскрытия информации.",
          href: "#reporting",
          external: false,
        },
        {
          date: "15.04.2024",
          cat: "Компания",
          title: "Меры поддержки пострадавших от паводков",
          excerpt: "Отсрочка платежей на 3 месяца и отмена штрафов и пени для клиентов из пострадавших районов области.",
          href: "/documents/flood-relief-2024.pdf",
          external: false,
        },
        {
          date: "2026",
          cat: "Малый бизнес",
          title: "Доля МСБ в ВВП Казахстана выросла до 40,9%",
          excerpt: "По итогам 2025 года вклад малого и среднего бизнеса в ВВП достиг 40,9%. В первом полугодии 2026 года количество субъектов предпринимательства составило 2,9 млн.",
          href: "https://www.gov.kz/memleket/entities/economy/press/news/details/1257656?lang=ru",
          external: true,
        },
      ],
    },
    apply: {
      title: "Подать заявку на финансирование",
      subtitle: "Оставьте контакты — менеджер свяжется с вами и подберёт условия.",
      fields: {
        name: "Имя",
        contactMethod: "Способ связи",
        region: "Регион",
        amount: "Желаемая сумма",
        comment: "Вопрос или комментарий",
      },
      contactMethods: [
        { value: "Телефон", label: "Телефон", fieldLabel: "Номер телефона", placeholder: "+7 (___) ___-__-__", type: "tel" },
        { value: "Почта", label: "Почта", fieldLabel: "Электронная почта", placeholder: "you@example.com", type: "email" },
        { value: "Другое", label: "Другое", fieldLabel: "Как с вами связаться", placeholder: "Укажите удобный способ", type: "text" },
      ],
      submit: "Отправить заявку",
      submitting: "Отправляем...",
      success: "Заявка принята, с вами свяжется наш специалист.",
      error: "Не удалось отправить заявку. Попробуйте ещё раз или позвоните нам.",
      errors: {
        name: "Укажите, как к вам обращаться",
        contact: "Укажите контакт для связи",
        region: "Выберите регион",
      },
      note: "Форма носит информационный характер: отправка ни к чему вас не обязывает. Контакты нужны только для связи с вами и не передаются третьим лицам.",
      recaptcha: {
        prefix: "Сайт защищён reCAPTCHA. Применяются ",
        privacy: "Политика конфиденциальности",
        and: " и ",
        terms: "Условия использования",
        suffix: " Google.",
      },
    },
    footer: {
      about: "Микрокредиты для агробизнеса и МСБ по всей Западно-Казахстанской области.",
      contactsTitle: "Контакты",
      phonesLabel: "Телефоны",
      addressLabel: "Адрес",
      address: "г. Уральск, пр. Н. Назарбаева, 166",
      menuTitle: "Разделы",
      legalTitle: "Реквизиты",
      legal: ["ТОО «МФО «Батыс Финанс»", "БИН: 000000000000", "www.mfobf.kz", "info@mfobf.kz"],
      rights: "Все права защищены.",
      disclaimer: "Разработано ТОО \"FinDos\" — лучший партнёр вашей МФО",
    },
  },

  kz: {
    langLabel: "KZ",
    brand: { line1: "BATYS", line2: "FINANCE", sub: "Микроқаржы ұйымы" },
    nav: [
      { id: "home", label: "Басты бет" },
      { id: "products", label: "Өнімдер" },
      { id: "news", label: "Жаңалықтар" },
      { id: "about", label: "Компания туралы" },
      { id: "reporting", label: "Есептілік" },
    ],
    cta: { apply: "Өтінім беру", products: "Біздің өнімдер", calculator: "Төлемді есептеу", more: "Толығырақ", all: "Барлық өнімдер", download: "Жүктеу", source: "Дереккөз" },
    hero: {
      badge: "Агробизнес пен ШОБ-ты қаржыландыру",
      titleLines: ["Бизнесіңізге", "жылдам", "қаржыландыру"],
      subtitle:
        "ЖК, шаруа қожалықтары мен ЖШС үшін микрокредиттер — бүкіл Батыс Қазақстан облысы бойынша. Шешім — 2 жұмыс күнінен бастап, артық бюрократиясыз.",
      chips: ["20 млн ₸ дейін", "шешім 2 күннен", "бүкіл БҚО бойынша"],
      scroll: "Төмен қараңыз",
    },
    who: {
      kicker: "Кімдерге арналған",
      title: "Мақсаттарыңызға сай қаржыландыру",
      subtitle: "ЖК, шаруа қожалықтары (ШҚ) және ЖШС үшін — икемді әрі нақты.",
      cards: [
        { icon: "recycle", title: "Айналым қаражатын толықтыру", desc: "Кассалық үзілістерді жауып, бизнесті жыл бойы қозғалыста ұстаңыз." },
        { icon: "tractor", title: "Техника мен жабдық сатып алу", desc: "Жұмысты тоқтатпай парк пен өндіріс қуатын жаңартыңыз." },
        { icon: "sprout", title: "Тұқым, ЖЖМ және тыңайтқыш", desc: "Егіс пен маусымға дайындықты уақытында қаржыландырыңыз." },
        { icon: "beef", title: "Мал сатып алу", desc: "Бас санын арттырып, шаруашылық өнімділігін өсіріңіз." },
        { icon: "briefcase", title: "Басқа да бизнес мақсаттар", desc: "Кәсіпорныңыздың міндеттеріне жеке шешімдер." },
      ],
    },
    advantages: {
      kicker: "Біздің артықшылықтарымыз",
      title: "Неге Батыс Финансты таңдайды",
      items: [
        { n: "01", title: "Жедел мақұлдау", desc: "Өтінім бойынша шешім — 2 жұмыс күнінен бастап." },
        { n: "02", title: "Ең аз құжат", desc: "Артық бюрократиясыз ықшам құжаттар пакеті." },
        { n: "03", title: "Икемді төлем кестесі", desc: "Бизнестің маусымдығы мен ақша ағынын ескереміз." },
        { n: "04", title: "Ашық шарттар", desc: "Жасырын комиссиялар жоқ — тек түсінікті мөлшерлемелер." },
        { n: "05", title: "20 млн теңгеге дейін", desc: "Кәсіпорын міндеттеріне сай қаржыландыру." },
      ],
    },
    figures: {
      kicker: "Сандармен Батыс Финанс",
      title: "Өңірдің сенімді серіктесі",
      stats: [
        { num: 2, prefix: "", suffix: "+ млрд ₸", label: "Қаржыландыру портфелі" },
        { num: 500, prefix: "", suffix: "+", label: "Өңір бойынша клиент" },
        { num: 19, prefix: "", suffix: " жыл", label: "БҚО нарығында" },
        { num: 2, prefix: "", suffix: " күннен", label: "Шешімнің орташа мерзімі" },
      ],
    },
    marquee: ["Жылдам", "Сенімді", "Ашық", "Агробизнес үшін", "Батыс Қазақстан"],
    products: {
      kicker: "Кредиттеу",
      title: "Бизнес пен жеке тұлғаларға арналған қаржыландыру",
      subtitle: "Кәсіпкерлерге, компанияларға және жеке клиенттерге қолайлы шешім таңдаймыз.",
      businessTitle: "Бизнеске арналған",
      individuals: {
        title: "Жеке тұлғаларды кредиттеу",
        desc: "Жеке клиенттердің өтініштерін қарап, қолайлы шешім таңдауға көмектесеміз.",
        note: "Шарттар мен қолжетімді бағдарламаларды маманнан нақтылаңыз.",
        rows: [
          ["Жасы", "21-ден 75 жасқа дейін"],
          ["Сомасы", "500 мыңнан 20 млн ₸ дейін"],
          ["Мерзімі", "12-ден 36 айға дейін"],
        ],
      },
      calculator: {
        kicker: "Калькулятор",
        title: "Есептік төлемді есептеңіз",
        amount: "Қаржыландыру сомасы",
        term: "Мерзімі",
        termUnit: "ай",
        result: "Алдын ала есеп",
        monthly: "Ай сайынғы төлем",
        total: "Қайтарылатын жалпы сома",
        overpayment: "Артық төлем",
        note: "Есеп алдын ала жасалады. Нақты шарттар өтінімді қарағаннан кейін анықталады.",
      },
      goals: [
        { name: "Айналым қаражатын толықтыру", desc: "Кассалық үзілістерді жауып, бизнесті жыл бойы қозғалыста ұстаңыз." },
        { name: "Техника мен жабдық сатып алу", desc: "Жұмысты тоқтатпай парк пен өндіріс қуатын жаңартыңыз." },
        { name: "Егіс және егін жинау науқаны", desc: "Тұқым, ЖЖМ және тыңайтқыш — маусымдық жұмыстарды уақытында қаржыландыру." },
        { name: "Мал сатып алу және ұстау", desc: "Мал басын көбейтіп, шаруашылықтың тұрақты жұмысын қамтамасыз етіңіз." },
        { name: "Өндірісті дамыту", desc: "Көлемді арттырып, жаңа бағыттарды іске қосып, бизнесті нығайтыңыз." },
        { name: "Үй-жайларды жөндеу және жаңғырту", desc: "Өндірістік және жұмыс орындарын компания міндеттеріне сай жаңартыңыз." },
        { name: "Басқа да бизнес мақсаттар", desc: "Кәсіпорныңыздың нақты міндеттеріне жеке шешімдер." },
      ],
      items: [
        {
          tag: "Маусымдық",
          name: "Агро-Маусым",
          desc: "Егіс пен егін жинау науқанын қаржыландыру, өнімді өткізгеннен кейін өтеу.",
          rows: [
            ["Сомасы", "20 млн ₸ дейін"],
            ["Мерзімі", "12 айға дейін"],
            ["Кестесі", "маусымдық, икемді"],
          ],
        },
        {
          tag: "Айналым",
          name: "Айналымдық",
          desc: "Бизнестің жыл бойы тұрақты жұмысы үшін айналым қаражатын толықтыру.",
          rows: [
            ["Сомасы", "15 млн ₸ дейін"],
            ["Мерзімі", "24 айға дейін"],
            ["Кестесі", "ай сайын / икемді"],
          ],
        },
        {
          tag: "Инвестиция",
          name: "Техника",
          desc: "Ауылшаруашылық техникасын, жабдықты сатып алу және өндірісті жаңғырту.",
          rows: [
            ["Сомасы", "20 млн ₸ дейін"],
            ["Мерзімі", "36 айға дейін"],
            ["Кестесі", "аннуитет / жеке"],
          ],
        },
      ],
    },
    how: {
      kicker: "Бұл қалай жұмыс істейді",
      title: "Қаржыландыруға дейін төрт қадам",
      steps: [
        { n: "01", title: "Өтінім", desc: "Онлайн өтінім қалдырыңыз немесе бізге қоңырау шалыңыз." },
        { n: "02", title: "Кеңес", desc: "Менеджер мақсатты нақтылап, шарттарды таңдайды." },
        { n: "03", title: "Шешім", desc: "Өтінім бойынша мақұлдау — 2 жұмыс күнінен бастап." },
        { n: "04", title: "Қаржыландыру", desc: "Қаражатты алып, ісіңізді дамытыңыз." },
      ],
    },
    geo: {
      kicker: "География",
      title: "Бүкіл Батыс Қазақстан облысы бойынша жұмыс істейміз",
      subtitle:
        "Бас кеңсе — Оралда. Өңірдің барлық аудандарындағы кәсіпорындар мен қожалықтарды қаржыландырамыз.",
      badge: "Орал — бас кеңсе",
      districts: [
        "Ақжайық ауданы", "Бәйтерек ауданы", "Бөкейорда ауданы", "Бөрлі ауданы",
        "Жаңақала ауданы", "Жәнібек ауданы", "Қазталов ауданы", "Қаратөбе ауданы",
        "Сырым ауданы", "Тасқала ауданы", "Теректі ауданы", "Шыңғырлау ауданы",
      ],
    },
    about: {
      kicker: "Компания туралы",
      title: "«МҚҰ «Батыс Финанс» ЖШС",
      lead:
        "Батыс Қазақстанның агробизнесі мен шағын және орта бизнесіне бағдарланған микроқаржы ұйымы.",
      paragraphs: [
        "Біз кәсіпкерлерге, шаруа қожалықтары мен компанияларға шынымен қажет кезде — егіске, техника сатып алуға, істі кеңейтуге — қаржыландыру алуға көмектесеміз.",
        "Біздің ұстанымымыз — ашық шарттар, орынды мерзімдер және әр клиентке жеке көзқарас. Агробизнестің маусымдығын түсініп, нақты ақша ағынына сай кесте құрамыз.",
        "Компания жұмысын «Теректа Финанс» («Теректі-Финанс» ШНҰ) атауымен бастап, кейін «Батыс Финанс» деп қайта аталды — команда мен өңір агробизнесімен жұмыс тәсілі сол қалпында сақталды.",
      ],
      values: [
        { title: "Ашықтық", desc: "Жасырын комиссиясыз түсінікті шарттар." },
        { title: "Жылдамдық", desc: "Артық бюрократиясыз жедел шешімдер." },
        { title: "Серіктестік", desc: "Әр іске жеке көзқарас." },
      ],
      historyKicker: "Компания тарихы",
      historyTitle: "Өңір кәсіпкерлерімен 19 жыл бірге",
      historyNote: "Алғашқы микрокредиттен — бизнесті жүйелі қолдауға дейін",
      history: [
        { year: "2007", title: "Компанияның құрылуы", desc: "Компания Батыс Қазақстанда жұмысын бастады." },
        { year: "2007–2008", title: "Микрокредиттеуді іске қосу", desc: "Алғашқы қаржыландыру бағдарламалары мен желінің дамуы." },
        { year: "2013–2015", title: "Әлеуметтік бағдарламалар", desc: "Өңірлік бастамалар мен сыртқы қаржыландыруды қолдау." },
        { year: "2015–2017", title: "Қатысуды кеңейту", desc: "Кеңселерді дамыту және өңір кәсіпкерлерімен жұмыс." },
        { year: "2016", title: "Ребрендинг", desc: "Компания «Батыс Финанс» брендімен жұмысын жалғастырды." },
        { year: "Бүгін", title: "Бизнесті қолдау", desc: "Шағын, орта және агробизнесті қаржыландыру." },
      ],
      awardsTitle: "Марапаттар мен танылу",
      awardsHint: "Құжатты көру үшін басыңыз",
      awards: [
        { title: "ҚазАгро дипломы «Үздік және сапалы есептер»", year: "2011" },
        { title: "ҚР Ауыл шаруашылығы министрлігінің Құрмет грамотасы", year: "2013" },
        { title: "«Ауыл шаруашылығын қаржылай қолдау қоры» АҚ Мақтау қағазы", year: "" },
        { title: "EBRD/CAMCO сертификаты «Батыс Қазақстан облысының үздік МҚҰ-ы»", year: "2013" },
        { title: "EBRD/CAMCO сертификаты «Батыс Қазақстан облысының үздік МҚҰ-ы»", year: "2015" },
        { title: "Қырғызстанның қаржы-несие мекемелерінде тағылымдамадан өту сертификаты", year: "2016" },
      ],
      license: {
        title: "Микроқаржы қызметіне арналған лицензия",
        number: "№ 07.21.0001.М",
        date: "18.02.2021 берілген",
        issuer:
          "ҚР Қаржы нарығын реттеу және дамыту агенттігінің Орал қаласындағы аймақтық өкілдер басқармасы берген.",
        note: "Құжаттың толық мәтіні — «Есептілік» бөлімінде",
      },
    },
    reporting: {
      kicker: "Есептілік",
      title: "Қаржылық есептілік және ақпаратты ашу",
      subtitle:
        "Біз ашықтық қағидатын ұстанамыз. Құжаттар мен есептілік танысуға қолжетімді.",
      docs: [
        {
          name: "Микроқаржы қызметіне арналған № 07.21.0001.М лицензия",
          meta: "JPG · 18.02.2021 берілген",
          href: "/documents/license-07-21-0001-m-kz.jpg",
        },
        {
          name: "Микрокредит бойынша берешекті реттеу нұсқаулығы",
          meta: "PDF · 27.05.2022 бек.",
          href: "/documents/debt-settlement-instruction-2022.pdf",
        },
        { name: "2025 жылғы қаржылық есептілік", meta: "PDF · 2025", href: "/documents/balance-2025.pdf" },
        { name: "2024 жылғы қаржылық есептілік", meta: "PDF · 2024", href: "/documents/balance-2024.pdf" },
        { name: "2023 жылғы қаржылық есептілік", meta: "PDF · 2023", href: "/documents/balance-2023.pdf" },
        { name: "2022 жылғы қаржылық есептілік", meta: "PDF · 2022", href: "/documents/balance-2022.pdf" },
        { name: "2021 жылғы қаржылық есептілік", meta: "PDF · 2021", href: "/documents/balance-2021.pdf" },
        { name: "2020 жылғы қаржылық есептілік", meta: "PDF · 2020", href: "/documents/balance-2020.pdf" },
      ],
    },
    news: {
      kicker: "Жаңалықтар",
      title: "Жаңалықтар мен оқиғалар",
      subtitle: "Батыс Финанста және өңірде не болып жатыр.",
      items: [
        {
          date: "01.08.2026",
          cat: "Нарық",
          title: "Қазақстанда астық түсімі — болжам шамамен 24 млн тонна",
          excerpt: "ҚР Ауыл шаруашылығы министрлігі: егін жинау науқаны өткен жылдан жылдам жүріп жатыр, майлы дақылдардың рекордтық түсімі күтілуде. АӨК-дегі несиелік тәуекелдер төмендейді — техника мен айналым қаражатын қаржыландыруға сұраныс артады.",
          href: "https://primeminister.kz/ru/news/prognoz-po-sboru-zerna-v-kazaxstane-sostavliaet-24-mln-tonn-minselxoz-30540",
          external: true,
        },
        {
          date: "20.07.2026",
          cat: "Нарық",
          title: "Ауыл шаруашылығының өсуі 4,4%-ға жеделдеді",
          excerpt: "2026 жылдың бірінші жартыжылдығында ауыл шаруашылығы жалпы өнімінің көлемі 4,4%-ға өсті, өсімдік шаруашылығы — 7,7%-ға. Салаға инвестициялар бес айда 36,4%-ға артты.",
          href: "https://inbusiness.kz/ru/last/selskoe-hozyajstvo-kazahstana-vyroslo-na-4-4",
          external: true,
        },
        {
          date: "15.05.2026",
          cat: "Нарық",
          title: "АӨК өнімдерінің экспорты 36%-ға өсті",
          excerpt: "2026 жылдың қаңтар-сәуірінде АӨК экспорты 3 млрд долларға жетті, жылдық жоспар — 7,2 млрд доллар. Шаруашылықтардың валюталық түсімі көбейді — айналым қаражатына сұраныс артады.",
          href: "https://www.kt.kz/rus/ekonomika/tokaev_prinyal_ministra_selskogo_hozyaystva_1377994694.html",
          external: true,
        },
        {
          date: "30.04.2025",
          cat: "Компания",
          title: "2024 жылғы қаржылық есептілік жарияланды",
          excerpt: "«Есептілік» бөлімінде компанияның өзекті қаржылық құжаттары қолжетімді — ақпаратты ашу талаптарына сәйкес.",
          href: "#reporting",
          external: false,
        },
        {
          date: "15.04.2024",
          cat: "Компания",
          title: "Су тасқынынан зардап шеккендерге қолдау шаралары",
          excerpt: "Облыстың зардап шеккен аудандарындағы клиенттер үшін төлемдерді 3 айға кейінге қалдыру және айыппұл мен өсімпұлды алып тастау.",
          href: "/documents/flood-relief-2024.pdf",
          external: false,
        },
        {
          date: "2026",
          cat: "Шағын бизнес",
          title: "Қазақстанның ЖІӨ-дегі ШОБ үлесі 40,9%-ға өсті",
          excerpt: "2025 жылдың қорытындысы бойынша шағын және орта бизнестің ЖІӨ-дегі үлесі 40,9%-ға жетті. 2026 жылдың бірінші жартыжылдығында кәсіпкерлік субъектілерінің саны 2,9 млн болды.",
          href: "https://www.gov.kz/memleket/entities/economy/press/news/details/1257656?lang=ru",
          external: true,
        },
      ],
    },
    apply: {
      title: "Қаржыландыруға өтінім беру",
      subtitle: "Байланыс қалдырыңыз — менеджер сізбен хабарласып, шарттарды таңдайды.",
      fields: {
        name: "Аты-жөні",
        contactMethod: "Байланыс тәсілі",
        region: "Аймақ",
        amount: "Қалаған сома",
        comment: "Сұрақ немесе түсініктеме",
      },
      contactMethods: [
        { value: "Телефон", label: "Телефон", fieldLabel: "Телефон нөмірі", placeholder: "+7 (___) ___-__-__", type: "tel" },
        { value: "Почта", label: "Пошта", fieldLabel: "Электрондық пошта", placeholder: "you@example.com", type: "email" },
        { value: "Другое", label: "Басқа", fieldLabel: "Сізбен қалай байланысуға болады", placeholder: "Ыңғайлы тәсілді көрсетіңіз", type: "text" },
      ],
      submit: "Өтінім жіберу",
      submitting: "Жіберілуде...",
      success: "Өтінім қабылданды, сізбен маманымыз хабарласады.",
      error: "Өтінімді жіберу мүмкін болмады. Қайта көріңіз немесе бізге хабарласыңыз.",
      errors: {
        name: "Сізге қалай жүгінуге болатынын көрсетіңіз",
        contact: "Байланыс деректерін көрсетіңіз",
        region: "Аймақты таңдаңыз",
      },
      note: "Форма ақпараттық сипатта: өтінім жіберу сізді ешнәрсеге міндеттемейді. Байланыс деректері тек сізбен хабарласу үшін қажет және үшінші тұлғаларға берілмейді.",
      recaptcha: {
        prefix: "Сайт reCAPTCHA арқылы қорғалған. Google ",
        privacy: "Құпиялылық саясаты",
        and: " және ",
        terms: "Пайдалану шарттары",
        suffix: " қолданылады.",
      },
    },
    footer: {
      about: "Бүкіл Батыс Қазақстан облысы бойынша агробизнес пен ШОБ-қа микрокредиттер.",
      contactsTitle: "Байланыс",
      phonesLabel: "Телефондар",
      addressLabel: "Мекенжай",
      address: "Орал қ., Н. Назарбаев даңғылы, 166",
      menuTitle: "Бөлімдер",
      legalTitle: "Деректемелер",
      legal: ["«МҚҰ «Батыс Финанс» ЖШС", "БСН: 000000000000", "www.mfobf.kz", "info@mfobf.kz"],
      rights: "Барлық құқықтар қорғалған.",
      disclaimer: "«FinDos» ЖШС әзірлеген — сіздің МҚҰ-ның үздік серіктесі",
    },
  },
};

export const phones = ["8 (705) 268-45-41", "8 (771) 306-61-61", "8 (777) 075-43-43"];
